import { redactShareTokens } from "./redactShareTokens"

function redactEmailQuery(value: string, depth = 0): string {
  return value.replace(
    /([?&])([^=?&#]+)=([^&#]*)/g,
    (match, prefix: string, key: string, query: string) => {
      try {
        if (decodeURIComponent(key).toLowerCase() === "email") {
          return `${prefix}${key}=[redacted]`
        }
        if (depth < 3) {
          const decoded = decodeURIComponent(query)
          if (decoded !== query) {
            const redacted = redactShareTokens(
              redactEmailQuery(decoded, depth + 1),
            )
            if (redacted !== decoded) {
              return `${prefix}${key}=${encodeURIComponent(redacted)}`
            }
          }
        }
      } catch {
        return match
      }
      return match
    },
  )
}

export function redactTelemetryUrl(value: string): string {
  return redactShareTokens(redactEmailQuery(value))
}
